"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var TableCell_1 = require("../TableCell");
var Text_1 = require("../Text");
var Cell = function (_a) {
    var _b = _a.column, align = _b.align, property = _b.property, primary = _b.primary, render = _b.render, context = _a.context, datum = _a.datum, scope = _a.scope, theme = _a.theme;
    if (theme) {
        var content = void 0;
        if (render) {
            content = render(datum);
        }
        else if (datum[property] !== undefined) {
            content = datum[property];
        }
        if (typeof content === 'string' || typeof content === 'number') {
            var textProps = primary ? theme.dataTable.primary : {};
            content = React.createElement(Text_1.Text, tslib_1.__assign({}, textProps), content);
        }
        return (React.createElement(TableCell_1.TableCell, tslib_1.__assign({ scope: scope }, (context && theme.dataTable[context]), { align: align }), content));
    }
};
var CellWrapper = recompose_1.compose(styled_components_1.withTheme)(Cell);
exports.Cell = CellWrapper;
//# sourceMappingURL=Cell.js.map